import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../../Redux/store';
import { DestinationContent } from './Interfaces/DestinationMainNav';
import { getDestinationMainNavData } from './DestinationMainNavService';

const initialState: DestinationContent = {
  isLoading: false,
  hasError: false,
};

const destinationContentSlice = createSlice({
  name: 'LoadDestinationMainNav',
  initialState,
  reducers: {
    loadingDestinationMainNav(state: DestinationContent, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    storeDestinationMainNavData(state: DestinationContent, action: PayloadAction<DestinationContent>) {
      if (action.payload) {
        const {
          payload: { data, hasError },
        } = action;
        state.data = data;
        state.hasError = hasError;
      }
    },
  },
});
export const LoadDestinationMainNavData = (): AppThunk => async (dispatch: any) => {
  dispatch(destinationContentSlice.actions.loadingDestinationMainNav(true));

  const destinationContent: DestinationContent = await getDestinationMainNavData();
  dispatch(destinationContentSlice.actions.storeDestinationMainNavData(destinationContent));
  dispatch(destinationContentSlice.actions.loadingDestinationMainNav(false));
};

export default destinationContentSlice.reducer;
